import { render, staticRenderFns } from "./FreightAdd.vue?vue&type=template&id=dc772e76&scoped=true"
import script from "./FreightAdd.vue?vue&type=script&lang=js"
export * from "./FreightAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc772e76",
  null
  
)

export default component.exports